module.exports = __webpack_public_path__ + "static/img/rongyu2.a74761a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rongyu2.png
// module id = PupA
// module chunks = 1